import { DateTime as DT } from 'luxon';
import { UserNameItem } from 'modules/user';
import { format$Price, formatPrice } from 'utils/helpers/functions/formatPrice';
import { withLocalCurrency } from 'utils/helpers/currency/currencyHelpers';
import { useSettings } from 'context/SettingsContext';
import EOverlay from 'components/others/EOverlay';
import { escapeHtml } from 'utils/helpers/functions/escapeHtml';
import CountBadge from '../../CounBadge';

const formatPaymentAmount = (amount: number, isUahMode: boolean) => {
    if (isUahMode) {
        return amount >= 0
            ? withLocalCurrency(formatPrice(amount))
            : withLocalCurrency(formatPrice(-amount), true);
    }
    return format$Price(amount);
};

interface Props {
    coming: Record<string, any>;
}

const ComingInfo = ({ coming }: Props) => {
    const { localSettings } = useSettings();
    const isUahMode = (Number(localSettings?.RATE?.current ?? 1) || 1) === 1;
    const price = Number(coming.operPrice || 0) * Number(coming.operCount || 0);
    const description = String(coming.operDescription || '').trim();

    return (
        <tr>
            <td className="date">
                <span className="d-block">{DT.fromMillis(coming.dt).toLocaleString(DT.DATE_MED)}</span>
                <span className="text-muted fs-12">{DT.fromMillis(coming.dt).toLocaleString(DT.TIME_SIMPLE)}</span>
            </td>
            <td className="user">
                <UserNameItem
                    smallMode
                    user={{
                        userName: coming.userName,
                        userEmail: coming.userEmail,
                        userPicture: coming.userPicture,
                    }}
                />
            </td>
            <td className="count">
                <CountBadge count={coming.operCount} />
            </td>
            <td className="price">
                <span className="d-block">{formatPaymentAmount(Number(coming.operPrice || 0), isUahMode)}</span>
            </td>
            <td className="amount">
                <span className="fw-bold">{formatPaymentAmount(price, isUahMode)}</span>
            </td>
            <td className="description">
                {description ? (
                    <EOverlay text={`<div>${escapeHtml(description)}</div>`} />
                ) : (
                    <span className="text-muted">-</span>
                )}
            </td>
        </tr>
    );
};

export default ComingInfo;
